import {connect} from 'react-redux'
import styles from './List.css'
import InfiniteScroll from 'react-infinite-scroller'
import {summaryRequest} from 'actions/inventory/summary'
import {getFormValues} from 'redux-form'
import moment from 'moment'

class List extends React.Component {
  render () {
    const {rowItems, search} = this.props

    return rowItems.length > 0 && <div className={styles['wrapper']}>
      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th className={styles.c20}>Name - Variant</th>
            <th className={styles.c12}>Category</th>
            {search && search.outletIds.length > 1 && <th className={styles.c12}>Outlet</th>}
            <th className={`text-center ${styles.c12}`}>Beginning</th>
            <th className={`text-center ${styles.c12}`}>Purchase Order</th>
            <th className={`text-center ${styles.c12}`}>Sales</th>
            <th className={`text-center ${styles.c12}`}>Transfer</th>
            <th className={`text-center ${styles.c12}`}>Adjustment</th>
            <th className={`text-center ${styles.c12}`}>Ending</th>
          </tr>
        </thead>
      </table>
      <div className={`${styles['table-content-wrapper']} summary-table-content-wrapper`}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}
          >
          <table className={`${styles['table-content']}`}>
            <tbody>
              {rowItems.map(this._renderRowItem)}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      </div>
  }

  _renderRowItem = (ri) => {
    let {search} = this.props
    if (ri.isParent && search) {
      if (ri.hasChildren) {
        return <tr>
          <td className={styles.c20}>{ri.item_name}</td>
          <td className={`${styles.c12}`}>{ri.category}</td>
          {search.outletIds.length > 1 &&
            <td className={`${styles.c12}`}>{ri.outlet}</td>}
          <td className={`text-center ${styles.c12}`} />
          <td className={`text-center ${styles.c12}`} />
          <td className={`text-center ${styles.c12}`} />
          <td className={`text-center ${styles.c12}`} />
          <td className={`text-center ${styles.c12}`} />
          <td className={`text-center ${styles.c12}`} />
        </tr>
      } else {
        return <tr>
          <td className={styles.c20}>{ri.item_name}</td>
          <td className={`${styles.c12}`}>{ri.category}</td>
          {search.outletIds.length > 1 &&
            <td className={`${styles.c12}`}>{ri.outlet}</td>}
          <td className={`text-center ${styles.c12}`}>{ri.beginning}</td>
          <td className={`text-center ${styles.c12}`}>{ri.purchase_order}</td>
          <td className={`text-center ${styles.c12}`}>{ri.sales}</td>
          <td className={`text-center ${styles.c12}`}>{ri.transfer}</td>
          <td className={`text-center ${styles.c12}`}>{ri.adjustment}</td>
          <td className={`text-center ${styles.c12}`}>{ri.ending}</td>
        </tr>
      }
    } else {
      return (
        <tr>
          <td>&nbsp;&nbsp; {ri.item_variant_name}</td>
          <td />
          {search.outletIds.length > 1 && <td />}
          <td className='text-center'>{ri.beginning}</td>
          <td className='text-center'>{ri.purchase_order}</td>
          <td className='text-center'>{ri.sales}</td>
          <td className='text-center'>{ri.transfer}</td>
          <td className='text-center'>{ri.adjustment}</td>
          <td className='text-center'>{ri.ending}</td>
        </tr>
      )
    }
  }

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onReachBottom = () => {
    const {currentPage, totalPage, dispatch, search: {date: {startDate, endDate}, keyword}, items, rowItems} = this.props
    if (currentPage < totalPage) {
      dispatch(summaryRequest({
        page: currentPage + 1,
        start_date: moment(startDate).format('YYYY/MM/DD'),
        end_date: moment(endDate).format('YYYY/MM/DD'),
        keyword
      }, items, rowItems))
    }
  }
}

function mapStateToProps (state) {
  const {rowItems, currentPage, totalPage, items} = state.inventory.summary
  return {
    rowItems,
    currentPage,
    totalPage,
    search: getFormValues('search')(state),
    items
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Summary/List/List.js